import { useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_USER_BRAND_LIKES } from "../api/brand-like";
import { FaHeart } from "react-icons/fa";

const MyBrandLikesShortcut = () => {
  const navigate = useNavigate();
  const { data, loading } = useQuery(GET_USER_BRAND_LIKES);

  const brandLikes = data?.getUserBrandLikes || [];

  // 좋아요한 브랜드가 없으면 숨김
  if (loading || brandLikes.length === 0) {
    return null;
  }

  return (
    <div
      onClick={() => {
        navigate("/campaigns/my-brand-likes");
      }}
      className="bg-white rounded-lg shadow-md p-4 cursor-pointer hover:shadow-lg transition-shadow"
    >
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 bg-red-50">
          <FaHeart className="text-red-500 w-6 h-6 fill-current" />
        </div>
        <div className="flex-1">
          <h3 className="font-bold text-lg text-black">내 좋아요 매장</h3>
        </div>
      </div>
    </div>
  );
};

export default MyBrandLikesShortcut;
